export enum SignaturePopupType {
  SEND_REMINDER = 'send-reminder',
  SIGN_DOCUMENT = 'sign-document',
  VIEW_DOCUMENT = 'view-document',
  VIEW_DOCUMENT_DETAILS = 'view-document-details',
  VIEW_SIGNATURES = 'view-signatures',
}
